import React from "react";
import { useParams } from "react-router-dom";
import { SubdomainNotFound } from "./SubdomainNotFound";

export const TenantNotFound = () => {
  const { tenantSlug } = useParams();
  
  // Detectar se é um subdomínio ou path-based
  const isSubdomain = !tenantSlug && window.location.hostname.includes('.');
  const subdomain = isSubdomain ? window.location.hostname.split('.')[0] : tenantSlug;

  // Se é subdomínio, mostrar página específica
  if (isSubdomain) {
    return <SubdomainNotFound subdomain={subdomain} />;
  }

  // Se é path-based, mostrar página original
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-foreground mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            Corretor não encontrado
          </h2>
          <p className="text-muted-foreground">
            O corretor <strong>"{tenantSlug}"</strong> não foi encontrado.
          </p>
        </div>
        
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Verifique se o endereço está correto ou entre em contato com o corretor para obter o link correto.
          </p>
          
          <a 
            href="/" 
            className="inline-block px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
          >
            Voltar ao início
          </a>
        </div>
      </div>
    </div>
  );
};